import { lazy, Suspense } from "react";
import { LazyMotion, domAnimation } from "framer-motion";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import ScrollToTop from "./components/ScrollToTop";
import AccessibilityWidget from "./components/AccessibilityWidget";

const RevKit = lazy(() => import("./pages/RevKit"));
const Listools = lazy(() => import("./pages/Listools"));
const RapidRebar = lazy(() => import("./pages/RapidRebar"));
const About = lazy(() => import("./pages/About"));
const NotFound = lazy(() => import("./pages/NotFound"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const TermsOfUse = lazy(() => import("./pages/TermsOfUse"));
const CancellationPolicy = lazy(() => import("./pages/CancellationPolicy"));
const AccessibilityStatement = lazy(() => import("./pages/AccessibilityStatement"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <LazyMotion features={domAnimation} strict>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/revkit" element={<RevKit />} />
            <Route path="/listools" element={<Listools />} />
            <Route path="/rapidrebar" element={<RapidRebar />} />
            <Route path="/about" element={<About />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfUse />} />
            <Route path="/cancellation" element={<CancellationPolicy />} />
            <Route path="/accessibility" element={<AccessibilityStatement />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
        <AccessibilityWidget />
      </BrowserRouter>
    </TooltipProvider>
    </LazyMotion>
  </QueryClientProvider>
);

export default App;
